import { render, staticRenderFns } from "./CardLogo.vue?vue&type=template&id=0da92539&scoped=true"
import script from "./CardLogo.vue?vue&type=script&lang=js"
export * from "./CardLogo.vue?vue&type=script&lang=js"
import style0 from "./CardLogo.vue?vue&type=style&index=0&id=0da92539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da92539",
  null
  
)

export default component.exports